import {Circle } from "lucide-react";
import { useState } from "react";
import "./image-slider.css";
import sliderImg from "../media/images/sliderImg.png";
const ImageSlider = ({images}) => {
    
    const [imageIndex,setImageIndex] = useState(0);
    function showNextImage(){
        setImageIndex(index=>{
            if(index===images.length -1) return 0
            return index+1
        })
    }
    function next(index){
        console.log(index);
        if (index===0){

        }
    }
    return (  
        <div className="Slider" >
            <div style={{width:"100%", height:"100%", display:"flex"}}>
                {images.map(url=>(
                    <img key={url} src={url.slika} className="img-slider-img" alt="s" style={{
                        translate:`${-100 * imageIndex}%`}}/>
                ))}
                {images.map((item,index)=>(
                <div key={index} >
                <div className="homeText" style={{display:index===imageIndex?"block":"none"}}>
                <div className="textDown">
                    <p>{item.textD}</p>
                </div>
                <div className="divider">
                </div>
                <div className="textUp">
                    <p >{item.textU1}</p>
                    <p >{item.textU2}</p>
                    <p>{item.textU3}</p>
                </div>
            </div>
                    </div>

            ))}
            </div>
            <div className="dugme">
                    <button onClick={showNextImage}><p>NEXT</p></button>
            </div>
            <div className="sliderImg">
                <img src={sliderImg} alt="slider"/>
            </div>
            <div  className="sliderIndc">
                {images.map((_,index)=>(
                    <button key={index} className="img-slider-dot-btn" onClick={()=>{setImageIndex(index); next(index)}}>{index=== imageIndex?<Circle style={{color:"#169f04", fill:"#169f04"}}/>: <Circle/>}</button>
                ))}
            </div>

        </div>
    );
}
 
export default ImageSlider;